export function getProjectAssetsBucketName(stage: string): string {
  const bucketStage = stage === 'staging' || stage === 'production' ? stage : 'qa';

  return `project-assets-${bucketStage}`;
}

export function getProjectAssetsBaseUrl(projectAssetsBucket: string, region = 'eu-west-1'): string {
  return `https://${projectAssetsBucket}.s3.${region}.amazonaws.com`;
}

export function getProjectAssetUrl(imageKey: string, projectAssetsBaseUrl: string): string {
  return new URL(imageKey, `${projectAssetsBaseUrl}/`).toString();
}
